import {createContext, useContext} from "react";
import {UseSuggestedAssignmentReturn} from "../hooks/useSuggestedAssignment";

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noopAsync = async () => false;
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noopAsyncVoid = async () => {};
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const defaultValue: UseSuggestedAssignmentReturn = {
  submit: noopAsyncVoid,
  cancel: noop,
  confirmCandidate: noopAsync,
  refreshUsage: noopAsyncVoid,
  state: "idle",
  candidates: [],
  error: null,
  validationErrors: [],
  isLoading: false,
  isAssigning: false,
  isActive: false,
  usageRemaining: null,
  usageLimit: null
};

const SuggestedAssignmentContext = createContext<UseSuggestedAssignmentReturn>(defaultValue);

const SuggestedAssignmentProvider = ({
  value,
  children
}: {
  value: UseSuggestedAssignmentReturn;
  children: React.ReactNode;
}) => {
  return <SuggestedAssignmentContext.Provider value={value}>{children}</SuggestedAssignmentContext.Provider>;
};

const useSuggestedAssignmentContext = () => useContext(SuggestedAssignmentContext);

export default SuggestedAssignmentProvider;
export {SuggestedAssignmentContext, useSuggestedAssignmentContext};
